import { Component, OnInit } from '@angular/core';
import { UrlResolverService } from '../_services/urlResolver.service';

@Component({
  selector: 'app-laboratorio',
  templateUrl: './laboratorio.component.html',
  styleUrls: ['./laboratorio.component.css'],
})
export class LaboratorioComponent implements OnInit {
  linkWhatsapp: string;
  hayMsje: boolean = false;

  constructor(private urlService: UrlResolverService) {}

  ngOnInit() {
    this.obtenerUrlWhatsappLab();
  }

  obtenerUrlWhatsappLab() {
    this.urlService.getUrlWhatsappLab().subscribe(
      (respuesta) => {
        if (respuesta.ok) {
          this.linkWhatsapp = respuesta.mensaje;
          this.hayMsje = true;
        } else {
          this.hayMsje = false;
        }
      },
      (error) => {
        console.log(error);
        this.hayMsje = false;
      }
    );
  }
}
